import { EditionsApiResponse } from './../models/editions-api-response';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EditionHeader } from '../models/edition-header.model';
import { BaseService } from './base.service';
import { Edition } from '../models/edition.model';
import { Moment } from 'moment';

@Injectable()
export class EditionsService {
  constructor(
    private httpClient: HttpClient,
    private baseService: BaseService
  ) {}

  getEditionHeader(startDate?: Date): Observable<EditionHeader> {
    const url = `${this.baseService.hostDomain}/api/editions/bystatistics`;
    return this.httpClient
      .post<EditionHeader>(url, {
        startDate: startDate
      })
      .pipe(
        catchError(err => {
          this.baseService.handleError(err, 'Obteniendo la edición actual');
          return [];
        })
      );
  }

  getEditionByDate(queryDate: Date): Observable<Edition> {
    const url = `${this.baseService.hostDomain}/api/editions/bydate`;
    return this.httpClient
      .post<Edition>(url, {
        startDate: queryDate
      })
      .pipe(
        catchError(err => {
          this.baseService.handleError(err, 'Consultando la edición');
          return [];
        })
      );
  }

  getEdition(id: string): Observable<Edition> {
    const url = `${this.baseService.hostDomain}/api/editions/${id}`;
    return this.httpClient.get<Edition>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Consultando la edición');
        return [];
      })
    );
  }

  getEditionsPag(
    page?: number,
    limit?: number
  ): Observable<EditionsApiResponse> {
    const url = `${this.baseService.hostDomain}/api/editions`;
    const data: any = {};
    if (page) {
      data.page = page;
    }
    if (limit) {
      data.limit = limit;
    }
    return this.httpClient.get<EditionsApiResponse>(url, { params: data }).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Buscando las ediciones');
        return [];
      })
    );
  }

  createEdition(startDate: Moment, endDate: Moment, closeDate: Moment) {
    const url = `${this.baseService.hostDomain}/api/editions`;
    const data: any = {};
    data.startDate = startDate;
    data.endDate = endDate;
    data.closeDate = closeDate;
    return this.httpClient.post(url, data).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Guardando edicion`);
        return [];
      })
    );
  }

  deleteEdition(id: string) {
    const url = `${this.baseService.hostDomain}/api/editions/delete/${id}`;
    return this.httpClient.delete(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Borrando edicion`);
        return [];
      })
    );
  }
}
